import React, { useEffect, useState } from "react";

/**
 * Componente para mostrar los clientes. La información de los cliente es estática, pero
 * la información de los testimónios es cargada desde el archivo .src/data/data.json -> "Testimonials" 
 *
 * @component
 * @example
 * 
 * "Testimonials": [
    {
      "name": "Joseph Paz",
      "citation": "Brand Manager / Administrador de Categorías - Reylácteos",
      "quote": "Trabajar con RAM ha sido una experiencia muy grata. Su enfoque centrado 
      en la satisfacción del cliente y sus habilidades estratégicas de negociación han sido 
      clave para alcanzar nuestros objetivos de marketing digital en nuestra campaña anual. 
      Valoramos sobre todo su disposición a satisfacer cualquier duda o requerimiento.  Son un 
      socio confiable para lograr metas y objetivos en estrategias de medios, especialmente en el 
      ámbito digital."
    }
  ]
 */

export const Clients = (props) => {
  const [activeSlide, setActiveSlide] = useState(1);
  const [width, setWidth] = React.useState(window.innerWidth);
  const breakpoint = 620;

  let current = 1;
  let length = 3;

  useEffect(() => {
    // This variable prevents race condition

    window.addEventListener("resize", () => setWidth(window.innerWidth));

    if (props.data)
      length = props.data.length;
  }, []);

  const next = () => {
    if (activeSlide === length)
      current = 1;
    else
      current = activeSlide + 1;

    setActiveSlide(current);
  };

  const prev = () => {
    if (activeSlide === 1)
      current = length;
    else
      current = activeSlide - 1;

    setActiveSlide(current);
  };

  return (
    <div id="clients">
      <div className="container-fluid padding-fluid">
        <hr className="hrGeneral"></hr>
        <div className="section-title text-center">
          <h2>Nuestros <span className="title">Clientes</span></h2>
        </div>
        <div className="row text-center">
          <div className="col-md-12">&nbsp;</div>
          <div className="col-md-12">&nbsp;</div>
          <div className="col-md-12">&nbsp;</div>
          <div className="col-md-12">
            <div className="col-md-2 col-xs-4 imagen">
              <img alt="rey queso" className="img-responsive" src="img/clients/reyqueso.webp"></img>
            </div>
            <div className="col-md-2 col-xs-4 imagen">
              <img alt="deuna" className="img-responsive" src="img/clients/d6_1.webp"></img>
            </div>
            <div className="col-md-2 col-xs-4 imagen">
              <img alt="uide" className="img-responsive" src="img/clients/uide-1.webp"></img>
            </div>
            <div className="col-md-2 col-xs-4 imagen">
              <img alt="diners club" className="img-responsive" src="img/clients/dinersclub.webp"></img>
            </div>
            <div className="col-md-2 col-xs-4 imagen">
              <img alt="titanium" className="img-responsive" src="img/clients/titanium.webp"></img>
            </div>
            <div className="col-md-2 col-xs-4 imagen">
              <img alt="titanium" className="img-responsive" src="img/clients/discover.webp"></img>
            </div>
          </div>
          <div className="col-md-12">
            <div className="col-md-2 col-xs-4 imagen">
              <img alt="" className="img-responsive" src="img/clients/Logos-Pepsi.webp"></img>
            </div>
            <div className="col-md-2 col-xs-4 imagen">
              <img alt="" className="img-responsive" src="img/clients/logo-gatorade.webp"></img>
            </div>
            <div className="col-md-2 col-xs-4 imagen">
              <img alt="" className="img-responsive" src="img/clients/MEGALABS_LOGO.webp"></img>
            </div>
            <div className="col-md-2 col-xs-4 imagen">
              <img alt="" className="img-responsive" src="img/clients/BancoPichincha_logo.webp"></img>
            </div>
            <div className="col-md-2 col-xs-4 imagen">
              <img alt="guitig" className="img-responsive" src="img/clients/guitig_logo.webp"></img>
            </div>
            <div className="col-md-2 col-xs-4 imagen">
              <img alt="" className="img-responsive" src="img/clients/autority-2.webp"></img>
            </div>
          </div>
          <div className="col-md-12">
            <div className="col-md-2 col-xs-4 imagen">
              <img alt="" className="img-responsive" src="img/clients/equinoccial.webp"></img>
            </div>
            <div className="col-md-2 col-xs-4 imagen">
              <img alt="" className="img-responsive" src="img/clients/logov220.webp"></img>
            </div>
            <div className="col-md-2 col-xs-4 imagen">
              <img alt="" className="img-responsive" src="img/clients/hospitalmetropolitano.webp"></img>
            </div>
            <div className="col-md-2 col-xs-4 imagen">
              <img alt="" className="img-responsive" src="img/clients/decameron_logo.webp"></img>
            </div>
            <div className="col-md-2 col-xs-4 imagen">
              <img alt="" className="img-responsive" src="img/clients/indurama_logo.webp"></img>
            </div>
            <div className="col-md-2 col-xs-4 imagen">
              <img alt="maresa" className="img-responsive" src="img/clients/maresa.webp"></img>
            </div>
          </div>
          <div className="col-md-12">
            <div className="col-md-2 col-xs-4 imagen">
              <img alt="Tesalia" className="img-responsive" src="img/clients/Tesalia-CBC.webp"></img>
            </div>
            <div className="col-md-2 col-xs-4 imagen">
              <img alt="graiman" className="img-responsive" src="img/clients/graiman_logo.webp"></img>
            </div>
            <div className="col-md-2 col-xs-4 imagen">
              <img alt="fybeca" className="img-responsive" src="img/clients/fybeca.webp"></img>
            </div>
            <div className="col-md-2 col-xs-4 imagen">
              <img alt="condado" className="img-responsive" src="img/clients/condado_logo.webp"></img>
            </div>
            <div className="col-md-2 col-xs-4 imagen">
              <img alt="multicines" className="img-responsive" src="img/clients/multicies_logo.webp"></img>
            </div>
            <div className="col-md-2 col-xs-4 imagen">
              <img alt="sanasana" className="img-responsive" src="img/clients/sanasana_logo.webp"></img>
            </div>
          </div>
          <div className="col-md-12">
            <div className="col-md-2 col-xs-4 imagen">
              <img alt="adelca" className="img-responsive" src="img/clients/adelca_logo.webp"></img>
            </div>
            <div className="col-md-2 col-xs-4 imagen">
              <img alt="teleamazonas" className="img-responsive" src="img/clients/teleamazonas_logo.webp"></img>
            </div>
            <div className="col-md-2 col-xs-4 imagen">
              <img alt="pycca" className="img-responsive" src="img/clients/pycca.webp"></img>
            </div>
            <div className="col-md-2 col-xs-4 imagen">
              <img alt="manicho" className="img-responsive" src="img/clients/manicho.webp"></img>
            </div>
            <div className="col-md-2 col-xs-4 imagen">
              <img alt="grupo farma" className="img-responsive" src="img/clients/grupofarma.webp"></img>
            </div>
            <div className="col-md-2 col-xs-4 imagen">
              <img alt="grupo farma" className="img-responsive" src="img/clients/bendo.webp"></img>
            </div>
          </div>
        </div>
        <div className="col-md-12">&nbsp;</div>
        <div className="row">
          <div className="col-md-1"></div>
          <div className="col-md-10 vertical-center1">
            <div className="col-md-1 vertical-center2" style={{ display: width < breakpoint ? 'none' : 'block' }}>
              <button id="btnLeft" aria-label="left" type="button" className="btn btn-custom vertical-center-button" onClick={prev}>
                <i className="fa-solid fa-angle-left fa-xs"></i>
              </button>
            </div>
            <div className={width < breakpoint ? "col-md-12 col-xs-12 text-center" : "col-md-10 text-center"}>
              <div className="row carousel__center">
                <ul className="carousel__list">
                  {props.data ? props.data.map((d, i) => {
                    const { citation, name, quote } = d;
                    const count = i + 1;
                    return (
                      <li
                        className={`carousel__item
                            ${count === activeSlide ? " active" : ""}
                            ${count < activeSlide ? " left" : ""}
                            ${count > activeSlide ? " right" : ""}
                          `}
                        key={count}
                      >
                        <blockquote className="carousel__quote">
                          <p className="quote">''</p>
                          <p className="texto">{quote}</p>
                          <p className="quote2">''</p>
                          <br></br>
                          <cite>
                            <span className="carousel__name">{name}</span>
                            <span className="carousel__citation">{citation}</span>
                          </cite>
                        </blockquote>
                      </li>
                    );
                  }) : ""}
                </ul>
              </div>
            </div>
            <div className="col-md-1 vertical-center2" style={{ display: width < breakpoint ? 'none' : 'block' }}>
              <button id="btnRight" aria-label="left" type="button" className="btn btn-custom vertical-center-button" onClick={next}>
                <i className="fa-solid fa-angle-right fa-xs"></i>
              </button>
            </div>
          </div>
          <div className="col-md-12 col-xs-12 text-center" style={{ display: width < breakpoint ? 'block' : 'none' }}>
            <button id="btnLeft2" aria-label="left" type="button" className="btn btn-custom vertical-center-button" onClick={prev}>
              <i className="fa-solid fa-angle-left fa-xs"></i>
            </button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <button id="btnRight2" aria-label="left" type="button" className="btn btn-custom vertical-center-button" onClick={next}>
              <i className="fa-solid fa-angle-right fa-xs"></i>
            </button>
          </div>
          <div className="col-md-1"></div>
        </div>
      </div>
    </div>
  );
};
